import { render, staticRenderFns } from "./banner2.vue?vue&type=template&id=7979d67b&"
var script = {}
import style0 from "./banner2.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports